import { removeCookie } from 'tiny-cookie'

const cookieItems = {
  amazon: [
    {
      name: 'amazon-pay-abtesting-new-widgets',
    },
    {
      name: 'session-id',
    },
    {
      name: 'session-id-time',
    },
    {
      name: 'session-token',
    },
    {
      name: 'ubid-main',
    },
  ],
  fb: [
    {
      name: 'fr',
    },
    {
      name: 'tr',
    },
    {
      name: 'fb/tr',
    },
    {
      name: 'cm/o/out',
    },
    {
      name: 'cm/l/out',
    },
    {
      name: 'cm/b/out',
    },
  ],
  ga: [
    {
      name: 'ads/ga-audiences',
    },
    {
      name: 'collect',
    },
    {
      name: '_ga',
    },
    {
      name: '_gid',
    },
    {
      name: '_gat',
    },
    {
      name: '_y',
    },
    {
      name: '_y',
    },
  ],
  ometria: [
    {
      name: 'ometria',
    },
  ],
  seedlip: [
    {
      name: 'stored-country',
    },
    {
      name: 'stored-country-modal',
    },
    {
      name: 'stored-modal-newsletter',
    },
  ],
  shopify: [
    {
      name: '_s',
    },
    {
      name: '_shopify_fs',
    },
    {
      name: '_shopify_s',
    },
    {
      name: '_shopify_sa_p',
    },
    {
      name: '_shopify_sa_t',
    },
    {
      name: '_shopify_uniq',
    },
    {
      name: '_shopify_visit',
    },
    {
      name: '_shopify_y',
    },
    {
      name: 'tracked_start_checkout',
    },
  ],
  vwo: [
    {
      name: '_vwo_uuid_v2',
    },
  ],
}

const cookies = {
  amazon(consent) {
    if (!consent) {
      cookieItems.amazon.forEach(cookie => removeCookie(cookie.name))
    }
  },
  fb(consent) {
    if (!consent) {
      cookieItems.fb.forEach(cookie => removeCookie(cookie.name))
    } else {
      // TODO: update FB pixel script useage in Shopify admin and theme.liquid
      // window.fbq('init', '1023014431145633')
      // window.fbq('track', 'PageView')
    }
  },
  ga(consent) {
    if (!consent) {
      cookieItems.ga.forEach(cookie => removeCookie(cookie.name))
    } else {
      window['ga-disable-UA-78305630-1'] = false

      if (window.ga) {
        window.ga('send', 'pageview')
      }
    }
  },
  ometria(consent) {
    if (!consent) {
      cookieItems.ometria.forEach(cookie => removeCookie(cookie.name))
    }
  },
  seedlip(consent) {
    if (!consent) {
      cookieItems.seedlip.forEach(cookie => removeCookie(cookie.name))
    }
  },
  shopify(consent) {
    if (!consent) {
      cookieItems.shopify.forEach(cookie => removeCookie(cookie.name))
    }
  },
  vwo(consent) {
    if (!consent) {
      cookieItems.vwo.forEach(cookie => removeCookie(cookie.name))
    }
  },
}

export default {
  amazon: cookies.amazon,
  fb: cookies.fb,
  ga: cookies.ga,
  ometria: cookies.ometria,
  seedlip: cookies.seedlip,
  shopify: cookies.shopify,
  vwo: cookies.vwo,
}
